export const correctStatus = 0;